import React from "react";
import classNames from "classnames";
import useFullScreen from "./useFullScreen";
import type { FullScreenProps } from "./dto";
import "./index.less";

import { ReactComponent as FullSvg } from "./assets/full-screen.svg";
import { ReactComponent as ExitSvg } from "./assets/exit-full-screen.svg";

/**
 * 全屏按钮
 */
const FullScreen: React.FC<FullScreenProps> = (props) => {
  const { style, className, container } = props;
  const [full, handleFullScreen] = useFullScreen(container);

  return (
    <span
      className={classNames("wbuc-full-screen-icon", {
        [className]: !!className,
      })}
      style={style}
      onClick={() => handleFullScreen()}
    >
      {full ? <ExitSvg /> : <FullSvg />}
    </span>
  );
};

export default FullScreen;

export { useFullScreen };
